/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */


export function getModelViewerAutoDimensionsHTML( xopts ) {
	const innerHtml = `
		<button slot="hotspot-dot+X-Y+Z" class="dot hide" data-position="1 -1 1" data-normal="1 0 0"></button>
		<button slot="hotspot-dim+X-Y" class="dim hide" data-position="1 -1 0" data-normal="1 0 0"></button>
		<button slot="hotspot-dot+X-Y-Z" class="dot hide" data-position="1 -1 -1" data-normal="1 0 0"></button>
		<button slot="hotspot-dim+X-Z" class="dim hide" data-position="1 0 -1" data-normal="1 0 0"></button>
		<button slot="hotspot-dot+X+Y-Z" class="dot hide" data-position="1 1 -1" data-normal="0 1 0"></button>
		<button slot="hotspot-dim+Y-Z" class="dim hide" data-position="0 -1 -1" data-normal="0 1 0"></button>
		<button slot="hotspot-dot-X+Y-Z" class="dot hide" data-position="-1 1 -1" data-normal="0 1 0"></button>
		<button slot="hotspot-dim-X-Z" class="dim hide" data-position="-1 0 -1" data-normal="-1 0 0"></button>
		<button slot="hotspot-dot-X-Y-Z" class="dot hide" data-position="-1 -1 -1" data-normal="-1 0 0"></button>
		<button slot="hotspot-dim-X-Y" class="dim hide" data-position="-1 -1 0" data-normal="-1 0 0"></button>
		<button slot="hotspot-dot-X-Y+Z" class="dot hide" data-position="-1 -1 1" data-normal="-1 0 0"></button>

		<svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" class="dimensionLineContainer lines hide">
			<line class="dimensionLine"></line>
			<line class="dimensionLine"></line>
			<line class="dimensionLine"></line>
			<line class="dimensionLine"></line>
			<line class="dimensionLine"></line>
		</svg>

		<div class="dim controls">
			<label><input type="checkbox" class="show-dimensions"> Show Dimensions</label>
		</div>`;
	return innerHtml;
}

export function getModelViewerAutoDimensionsStyle() {
	return `
		<style>
			.md-model .dot {
				display: none;
			}

			.md-model .dim {
				background: #fff;
				border-radius: 4px;
				border: none;
				box-sizing: border-box;
				box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
				color: rgba(0, 0, 0, 0.8);
				display: block;
				font-size: 9px;
				max-width: 128px;
				overflow-wrap: break-word;
				padding: 0.25em 0.5em;
				position: absolute;
				width: max-content;
				height: max-content;
				transform: translate3d(-50%, -50%, 0);
				pointer-events: none;
				--min-hotspot-opacity: 0;
			}

			@media only screen and (max-width: 800px) {
				.md-model .dim {
					font-size: 2.5vw;
				}
			}

			.md-model .dim.controls {
				position: absolute;
				bottom: 16px;
				left: 16px;
				max-width: unset;
				transform: unset;
				pointer-events: auto;
				z-index: 100;
				padding: 0;
			}
			.md-model .dim.controls > label {
				padding: 0.5em 0.75em 0.5em 0;
			}

			.md-model .dimensionLineContainer {
				pointer-events: none;
				display: block;
			}

			.md-model .dimensionLine {
				stroke: #16a5e6;
				stroke-width: 2;
				stroke-dasharray: 2;
			}

			.md-model .hide {
				display: none;
			}

			/* This keeps child nodes hidden while the element loads */
			.md-model :not(:defined) > * {
				display: none;
			}
		</style>`;
}


export function setupModelViewerAutoDimensions( md_trg, modelViewer, xopts ) {

	const checkbox = modelViewer.querySelector('.show-dimensions');

	function setVisibility(element) {
		if( checkbox.checked) {
			element.classList.remove('hide');
		} else {
			element.classList.add('hide');
		}
	}

	checkbox.addEventListener( 'change', () => {
		setVisibility(modelViewer.querySelector('.lines'));
		modelViewer.querySelectorAll('button').forEach( (hotspot) => {
			setVisibility(hotspot);
		} );
	} );

	function drawLine( svgLine, dotHotspot1, dotHotspot2, dimensionHotspot ) {
		if( dotHotspot1 && dotHotspot1) {
			svgLine.setAttribute('x1', dotHotspot1.canvasPosition.x);
			svgLine.setAttribute('y1', dotHotspot1.canvasPosition.y);
			svgLine.setAttribute('x2', dotHotspot2.canvasPosition.x);
			svgLine.setAttribute('y2', dotHotspot2.canvasPosition.y);

			// use provided optional hotspot to tie visibility of this svg line to
			if( dimensionHotspot && !dimensionHotspot.facingCamera ) {
				svgLine.classList.add('hide');
			} else {
				svgLine.classList.remove('hide');
			}
		}
	}

	const lines = modelViewer.querySelectorAll('line');

	const renderSVG = () => {
		drawLine(lines[0], modelViewer.queryHotspot('hotspot-dot+X-Y+Z'), modelViewer.queryHotspot('hotspot-dot+X-Y-Z'), modelViewer.queryHotspot('hotspot-dim+X-Y'));
		drawLine(lines[1], modelViewer.queryHotspot('hotspot-dot+X-Y-Z'), modelViewer.queryHotspot('hotspot-dot+X+Y-Z'), modelViewer.queryHotspot('hotspot-dim+X-Z'));
		drawLine(lines[2], modelViewer.queryHotspot('hotspot-dot+X+Y-Z'), modelViewer.queryHotspot('hotspot-dot-X+Y-Z')); // always visible
		drawLine(lines[3], modelViewer.queryHotspot('hotspot-dot-X+Y-Z'), modelViewer.queryHotspot('hotspot-dot-X-Y-Z'), modelViewer.queryHotspot('hotspot-dim-X-Z'));
		drawLine(lines[4], modelViewer.queryHotspot('hotspot-dot-X-Y-Z'), modelViewer.queryHotspot('hotspot-dot-X-Y+Z'), modelViewer.queryHotspot('hotspot-dim-X-Y'));
	};

	modelViewer.addEventListener( 'camera-change', renderSVG );

	modelViewer.addEventListener( 'load', () => {
		const center = modelViewer.getBoundingBoxCenter();
		const size = modelViewer.getDimensions();
		const x2 = size.x / 2;
		const y2 = size.y / 2;
		const z2 = size.z / 2;

		modelViewer.updateHotspot({
			name: 'hotspot-dot+X-Y+Z',
			position: `${center.x + x2} ${center.y - y2} ${center.z + z2}`
		});

		modelViewer.updateHotspot({
			name: 'hotspot-dim+X-Y',
			position: `${center.x + x2 * 1.2} ${center.y - y2 * 1.1} ${center.z}`
		});
		modelViewer.querySelector('button[slot="hotspot-dim+X-Y"]').textContent =
			`${(size.z * 100).toFixed(0)} cm`;

		modelViewer.updateHotspot({
			name: 'hotspot-dot+X-Y-Z',
			position: `${center.x + x2} ${center.y - y2} ${center.z - z2}`
		});

		modelViewer.updateHotspot({
			name: 'hotspot-dim+X-Z',
			position: `${center.x + x2 * 1.2} ${center.y} ${center.z - z2 * 1.2}`
		});
		modelViewer.querySelector('button[slot="hotspot-dim+X-Z"]').textContent =
			`${(size.y * 100).toFixed(0)} cm`;

		modelViewer.updateHotspot({
			name: 'hotspot-dot+X+Y-Z',
			position: `${center.x + x2} ${center.y + y2} ${center.z - z2}`
		});

		modelViewer.updateHotspot({
			name: 'hotspot-dim+Y-Z',
			position: `${center.x} ${center.y + y2 * 1.1} ${center.z - z2 * 1.1}`
		});
		modelViewer.querySelector('button[slot="hotspot-dim+Y-Z"]').textContent =
			`${(size.x * 100).toFixed(0)} cm`;

		modelViewer.updateHotspot({
			name: 'hotspot-dot-X+Y-Z',
			position: `${center.x - x2} ${center.y + y2} ${center.z - z2}`
		});

		modelViewer.updateHotspot({
			name: 'hotspot-dim-X-Z',
			position: `${center.x - x2 * 1.2} ${center.y} ${center.z - z2 * 1.2}`
		});
		modelViewer.querySelector('button[slot="hotspot-dim-X-Z"]').textContent =
			`${(size.y * 100).toFixed(0)} cm`;

		modelViewer.updateHotspot({
			name: 'hotspot-dot-X-Y-Z',
			position: `${center.x - x2} ${center.y - y2} ${center.z - z2}`
		});

		modelViewer.updateHotspot({
			name: 'hotspot-dim-X-Y',
			position: `${center.x - x2 * 1.2} ${center.y - y2 * 1.1} ${center.z}`
		});
		modelViewer.querySelector('button[slot="hotspot-dim-X-Y"]').textContent =
			`${(size.z * 100).toFixed(0)} cm`;

		modelViewer.updateHotspot({
			name: 'hotspot-dot-X-Y+Z',
			position: `${center.x - x2} ${center.y - y2} ${center.z + z2}`
		});

		renderSVG();
	} );

}

